import _ from 'lodash';
import { combineReducers } from 'redux';

import types from 'frontend/state/actionTypes';

const INITIAL_STATE = [
  [false, false, false],
  [false, false, false],
  [false, false, false],
  [false, false, false],
  [false, false, false],
  [false, false, false],
  [false, false, false],
];

const talentStringToArray = talents => {
  const result = [];

  if (talents) {
    for (let i = 0; i < talents.length; i += 1) {
      const row = [false, false, false];
      const x = parseInt(talents[i]);
      row[x - 1] = true;
      result.push(row);
    }
  }

  return result;
};

const selectedTalentsReducer = (state = INITIAL_STATE, action = {}) => {
  const { type, payload } = action;

  // SUPER HACK
  if (state === true || !_.isArray(state)) {
    return INITIAL_STATE;
  }

  switch (type) {
    case types.RESET_OPTIMIZE_TALENTS:
      return INITIAL_STATE;
    case types.SET_OPTIMIZE_TALENTS:
      return talentStringToArray(payload);
    case types.INPUT_OPTIMIZE_TEXT: {
      return talentStringToArray(payload.talents);
    }
    case types.TOGGLE_OPTIMIZE_TALENT: {
      const { row, col } = payload;
      return _.map(state, (stateRow, r) => {
        if (r === row) {
          return _.map(stateRow, (stateCol, c) => {
            if (c === col) {
              return Boolean(!stateCol);
            }
            return Boolean(stateCol);
          });
        }
        return stateRow;
      });
    }
    case types.LOAD_OPTIMIZE_REPORT:
      if (!_.isArray(payload.optimize.selectedTalents)) {
        return INITIAL_STATE;
      }
      return payload.optimize.selectedTalents;
    default:
      return state;
  }
};

const lockedTalentsReducer = (state = [], action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case types.TOGGLE_OPTIMIZE_LOCKED_TALENT: {
      if (_.includes(state, payload.talents)) {
        return _.without(state, payload.talents);
      }
      return [...state, payload.talents];
    }
    case types.LOAD_OPTIMIZE_REPORT:
      return payload.optimize.lockedTalents;
    default:
      return state;
  }
};

export default combineReducers({
  selected: selectedTalentsReducer,
  locked: lockedTalentsReducer,
});
